import {
  useQuery,
  UseQueryResult,
} from '@tanstack/react-query';
import {
  normalizeFilterableSettings,
} from 'core/Filters/util';
import {
  SettingsDTO,
  TempoPatientDetailDTO,
} from 'dtos';
import {
  getApiSettingsGetTempoDashboardFilterSettings,
  postApiTempoDashboardGetPatientDetail,
} from 'endpoints';
import {
  serializeDateRange,
} from 'pages/Dashboard/transport/dateRange';
import {
  DateRange,
} from 'types/dateRange';

export function useGetTempoDashboardFilterSettings() {
  return useQuery<SettingsDTO, Error>({
    queryKey: ['tempo-dashboard-filter-settings'],
    queryFn: getApiSettingsGetTempoDashboardFilterSettings,
  });
}

export function useTempoDashboardFilterMetaComponents() {
  const { data } = useGetTempoDashboardFilterSettings();

  return normalizeFilterableSettings(data?.filterableSettings ?? []);
}

export default function useGetTempoPatientDetail(
  patientId: number,
  dateRange: DateRange,
): UseQueryResult<TempoPatientDetailDTO, Error> {
  const serializedDateRange = serializeDateRange(dateRange);

  return useQuery<TempoPatientDetailDTO, Error>({
    queryKey: ['tempo-patient-detail', patientId, serializedDateRange?.start, serializedDateRange?.end],
    queryFn: () => postApiTempoDashboardGetPatientDetail({
      patientId,
      dateRange: serializedDateRange,
    }),
    enabled: patientId > 0,
  });
}
